import OrganizationRole from '../enums/organization-roles';

interface ListOrganization {
  id: string;
  name: string;
  role: OrganizationRole;
  robotCount: number;
  userCount: number;
  subOrganizationCount: number | null;
  parentId: string | null;
  parentName: string | null;
  require2fa: boolean;
  enforceSSO: boolean;
  skipThirdPartyTwoFa: boolean;
}
export interface OrganizationTreeNode extends Pick<ListOrganization, 'id' | 'name' | 'role' | 'parentId'> {
  country: string
}

export const defaultListOrganizationState = {
  id: '',
  name: '',
  role: OrganizationRole.CUSTOMER,
  robotCount: 0,
  userCount: 0,
  subOrganizationCount: null,
  parentId: null,
  parentName: '',
  require2fa: false,
  enforceSSO: false,
  skipThirdPartyTwoFa: false,
} as ListOrganization;

export default ListOrganization;

// mock data

export const mockListManufacturer = {
  id: '8235c308-14f7-4672-95ea-49115443de9b',
  name: 'PARENT',
  role: OrganizationRole.MANUFACTURER,
  robotCount: 0,
  parentId: null,
  userCount: 0,
  subOrganizationCount: 0,
} as ListOrganization;

export const mockListDistributor = {
  id: '2c6e3109-1aaa-4e12-9091-324f01eef48a',
  name: 'BIMO AS',
  role: OrganizationRole.DISTRIBUTOR,
  robotCount: 0,
  parentId: mockListManufacturer.id,
  userCount: 0,
  subOrganizationCount: 0,
} as ListOrganization;

export const mockListCustomer = {
  id: '0909090',
  name: 'SOME CUSTOMER',
  role: OrganizationRole.CUSTOMER,
  robotCount: 0,
  parentId: mockListDistributor.id,
  userCount: 0,
  subOrganizationCount: 0,
} as ListOrganization;

export const mockListLocation = {
  id: '0000',
  name: 'SOME DISTR',
  role: OrganizationRole.LOCATION,
  robotCount: 0,
  parentId: mockListDistributor.id,
  userCount: 0,
  subOrganizationCount: 0,
} as ListOrganization;
